const FormatMinMax = (props) => {
  const { num } = props
  let n = num

  let split = num.toFixed(2)
  let split2 = split.split('.')
  let afterdot = `.${split2[1]}`

  let splitstr = `${n}`.split('.')

  return splitstr[0] + afterdot
}
export default FormatMinMax
